module.exports = __webpack_public_path__ + "media/images/padlet_logo_white-cb006fc7fe5a13118f68f2a2da012cb7.svg";